module.exports = __webpack_public_path__ + "img/be.9ea21dc0.svg";